module.exports = __webpack_public_path__ + "static/media/client_icon.dc31f418.svg";